// extracted by mini-css-extract-plugin
export default {"section_cards":"cards_section_cards__9+q6v","btn_container":"cards_btn_container__WGO7B","cards_container":"cards_cards_container__4Xn4Z","card":"cards_card__8zjnS"};